export default {
	"ckrxm": "카드 소유자 이름",
	"qsrckrxm": "카드 소유자 이름을 입력하세요",
	"ssyh": "소속 은행",
	"qsrssyh": "소속 은행을 입력하세요",
	"qrzjdyhkh": "카드 번호를 정확히 확인하세요. 카드 번호 오류 시 자금이 입금되지 않을 수 있습니다.",
	"qsryhkh": "카드 번호를 입력하세요",
	"qrzjdkhh": "계좌 개설 은행을 정확히 확인하세요. 오류 시 수동으로 수정해 주세요.",
	"qsrkhhdz": "계좌 개설 은행 주소를 입력하세요",
	"qrtj": "추가 확인",
	"bm": "별명",
	"bmnbyqfnmxd": "별명은 본인 명의의 계좌를 쉽게 구분할 수 있도록 도와줍니다",
	"zh": "계좌",
	"sjhm": "휴대폰 번호",
	"sjh": "휴대폰",
	"qsrsjhm": "휴대폰 번호를 입력하세요",
	"qrzjdxnbdz": "가상 화폐 주소를 정확히 확인하세요. TRC20만 지원합니다.",
	"zhcwzjjwfdz": "계좌 오류로 인해 자금이 입금되지 않을 수 있습니다.",
	"qrzjdxnbdzzhcwzjjwfdz": "가상 화폐 주소를 정확히 확인하세요. 계좌 오류 시 자금이 입금되지 않을 수 있습니다.",
	"qsr": "입력하세요",
	"dz1": "주소",
	"qrzjd": "정확히 확인하세요",
	"zhzhcwzjjwfdd": "계좌 오류 시 자금이 입금되지 않을 수 있습니다.",
	"scsbqcs": "업로드 실패, 다시 시도하세요",
	"tj": "추가",
	"tjzhcg": "계좌 추가 성공",
	"zdy": "사용자 정의",
	"z": "부터",
	"qx": "취소",
	"qd": "확인",
	"zdxq": "베팅 내역 상세",
	"jbxx": "기본 정보",
	"jsxx": "정산 정보",
	"tz": "베팅",
	"yxtz": "유효 베팅",
	"sy": "승패",
	"zdzt": "베팅 상태",
	"yjs": "정산 완료",
	"wjs": "미정산",
	"y1": "승",
	"s": "패",
	"zdh": "베팅 번호",
	"tzsj": "베팅 시간",
	"jssj": "정산 시간",
	"tjsj": "통계 시간",
	"sksz": "수금 설정",
	"jktj": "추가만 가능",
	"qb": "지갑",
	"jzz": "로딩 중",
	"zw": "데이터 없음",
	"qtj": "추가해 주세요",
	"xz": "신규",
	"tjxd": "새 항목 추가",
	"qbdz": "지갑 주소",
	"ts": "알림",
	"nhwszqkmm": "출금 비밀번호가 설정되지 않았습니다",
	"qsz": "설정하러 가기",
	"qxzqkqb": "출금 지갑을 선택하세요",
	"nhwbdgrxx": "개인 정보를 아직 연결하지 않았습니다",
	"qbd": "연결하러 가기",
	"fzlj": "링크 복사",
	"bctp": "이미지 저장",
	"xzcg": "다운로드 완료",
	"fxzq": "공유하고 수익 얻기",
	"yqlj": "초대 링크",
	"ljyq": "즉시 초대",
	"ck": "입금",
	"ckjl": "입금 기록",
	"zfqd": "결제 수단",
	"ckje": "입금 금액",
	"zdje": "최대 금액",
	"cubz": "입금 메모",
	"ljck": "즉시 입금",
	"czydwt": "충전 시 문제가 발생했나요?",
	"lxkf": "고객센터 문의",
	"jj": "해결하기",
	"qsrckje": "입금 금액을 입력하세요",
	"y2": "위안",
	"qsrckbz": "입금 메모를 입력하세요",
	"ljzf": "즉시 결제",
	"clz": "처리 중",
	"cg1": "성공",
	"sb": "실패",
	"zf": "무효",
	"je": "금액",
	"jysj": "거래 시간",
	"xq": "상세 정보",
	"zwgdjl": "더 이상 기록이 없습니다",
	"zwsj": "데이터 없음",
	"wz": "알 수 없음",
	"yhk": "은행카드",
	"zfb": "알리페이",
	"wx": "위챗",
	"szrmb": "디지털 위안화",
	"ysf": "유니온페이 퀵패스",
	"szqb": "디지털 지갑",
	"qk": "출금",
	"dqxtzccxjsgytzjl": "현재 시스템은 최근 3개월의 베팅 기록만 조회할 수 있습니다",
	"qq": "QQ지갑",
	"bmh": "BMH 충전",
	"jssjbxdykssj": "종료 시간은 시작 시간보다 늦어야 합니다",
	"jzccxjsydjl": "최근 3개월의 기록만 조회할 수 있습니다",
	"jsrqyxydqrz": "종료 날짜는 현재 날짜보다 작아야 합니다",
	"ye": "잔액",
	"zjmx": "자금 내역",
	"zbjl": "계좌 변경 기록",
	"cqjl": "입출금 기록",
	"qhyx": "게임 전환",
	"dq": "현재",
	"fhzy": "홈으로 돌아가기",
	"cxjz": "다시 로드",
	"zskf": "전담 고객센터",
	"tzsx": "TZ 라이브",
	"cp": "복권",
	"zr": "라이브",
	"ty": "스포츠",
	"dz": "슬롯",
	"by": "낚시 게임",
	"qp": "보드게임",
	"qsryxmcss": "게임 이름을 입력하여 검색하세요",
	"ss": "검색",
	"qbyx": "모든 게임",
	"scyx": "즐겨찾기 게임",
	"whz": "점검 중",
	"zr1": "인기",
	"rm": "핫",
	"zwgdyx": "더 이상 게임이 없습니다",
	"qxsc": "즐겨찾기 해제",
	"sccg": "즐겨찾기 추가 완료",
	"dsjzypm": "휴대폰 홈화면으로 이동",
	"yxdt": "게임 로비",
	"zrsx": "라이브 카지노",
	"cxyzqj": "한 방에 큰돈을 노리세요",
	"cggdyl": "감각을 깨우는 오락",
	"xc": "현장",
	"mxycjf": "꿈이 현실로",
	"cpkqqj": "복권이 기적을 만듭니다",
	"zjdhy": "존경하는 회원님, 천자더리(天子德利)에 오신 것을 환영합니다!",
	"qb1": "전체",
	"xjye": "잔액",
	"yh": "활동",
	"tg": "홍보",
	"nhwdl": "아직 로그인하지 않았습니다",
	"dlzchck": "로그인/회원가입 후 확인하세요",
	"tzgg": "공지사항",
	"wzdl": "알겠습니다",
	"jrbztc": "오늘은 다시 표시하지 않기",
	"zryltytz": "라이브 카지노, 스포츠 베팅, 슬롯 등 모든 오락이 손 안에",
	"appxz": "APP 설치",
	"qbyd": "모두 읽음",
	"sx": "새로 고침",
	"xxzx": "메시지 센터",
	"ptgg": "플랫폼 공지",
	"xttz": "시스템 알림",
	"zy": "중요",
	"zwgdtz": "더 이상 알림이 없습니다",
	"zbxq": "계좌변동 상세",
	"xjqb": "현금 지갑",
	"gldd": "연관 주문",
	"zbqye": "변경 전 금액",
	"zbye": "변경 금액",
	"zbhye": "변경 후 금액",
	"zbsj": "변경 시간",
	"qsrzh": "아이디를 입력하세요",
	"qsrmm": "비밀번호를 입력하세요",
	"wjmm": "비밀번호 저장",
	"dl": "로그인",
	"hmyzh": "아직 계정이 없으신가요?",
	"qzc": "회원가입",
	"qsrdlxx": "로그인 정보를 입력하세요",
	"qzcsrmm": "비밀번호를 다시 입력하세요",
	"qsryqm": "초대 코드를 입력하세요",
	"bz": "통화",
	"qsryzm": "인증 코드를 입력하세요",
	"zc": "회원가입",
	"yyzh": "이미 계정이 있으신가요?",
	"qdl": "로그인하기",
	"zccg": "회원가입 성공",
	"qsrzcxx": "회원가입 정보를 입력하세요",
	"lcmmbyz": "두 번 입력한 비밀번호가 일치하지 않습니다",
	"zds": "베팅 건수",
	"tzze": "총 베팅 금액",
	"ljsy": "누적 승패",
	"y": "월",
	"r": "일",
	"zyk": "총 손익",
	"yxsy": "게임 승패",
	"fsje": "환급 금액",
	"zdbs": "베팅 건수",
	"tzzl": "총 베팅량",
	"yqfsje": "예상 환급 금액",
	"wdfsbl": "내 환급 비율",
	"jr": "오늘",
	"yx": "게임",
	"ssfsje": "실제 수령 환급 금액",
	"ssfs": "실제 환급",
	"cg": "카지노",
	"zj": "총계",
	"b1": "건",
	"wdyx": "내 게임",
	"tzjl": "베팅 기록",
	"cgyl": "카지노 수익",
	"yqfs": "예상 환급",
	"wdqb": "내 지갑",
	"yjhs": "원클릭 회수",
	"djye": "동결 잔액",
	"qkjl": "출금 기록",
	"czcg": "작업 성공",
	"tzxq": "공지 상세",
	"yhhd": "프로모션",
	"qbyh": "전체 혜택",
	"fllqhdxq": "복지 수령 이벤트 상세",
	"jthdnrjxfbg": "이벤트 상세 내용은 아래 표를 참고하세요",
	"tlqlqd": "T채팅방 출석체크",
	"zscj": "보너스 지급",
	"xf": "하향 전환",
	"blsxf": "배수 롤링 후 하향 전환",
	"dyt": "1일차",
	"det": "2일차",
	"dst": "3일차",
	"dst1": "4일차",
	"dwt": "5일차",
	"dlt": "6일차",
	"dqt": "7일차",
	"mtsc100": "매일 첫 충전 100위안",
	"hdgz": "이벤트 규칙",
	"mtck": "매일 충전 후 채팅방에 충전 스크린샷을 보내고 관리자에게 출석체크 및 계정 보고하여 보너스를 수령하세요. 일부 차익 거래 또는 규칙 위반 회원은 참여할 수 없습니다.",
	"tzdl": "천자더리(天子德利)는 이 이벤트에 대한 해석권 및 종료권을 보유하며, 여러분의 이해와 지원에 감사드립니다.",
	"czje": "충전 금액",
	"tx": "출금",
	"bls": "배 롤링",
	"b": "배",
	"lqgz": "수령 규칙",
	"txls": "출금 롤링",
	"drxrczdeb": "신규 유저 당일 두 번째 충전",
	"drxrczdsb": "신규 유저 당일 세 번째 충전",
	"sbck": "첫 충전",
	"ebck": "두 번째 충전",
	"sdtzdldxhdhtyjb": "천자더리의 문자 또는 전화로 초대된 VIP",
	"ygipzyxlqyc": "하나의 IP당 1회만 수령 가능",
	"bdtl": "일부 차익 거래는 규정 위반으로 참여 불가",
	"bgsxysyhdjsq": "본사는 모든 이벤트에 대한 해석권을 보유하며, 이해와 지지에 감사드립니다",
	"ygyhygid": "하나의 유저(ID), 하나의 기기에서만 1회 수령 가능",
	"jzrhtdtlhym": "개인 또는 팀의 부정 이용(차익거래) 금지. 적발 시 보너스 회수 및 계정 정지 조치",
	"sylqcjbncycpyx": "수령한 보너스로는 복권 및 제3자 실시간 게임 참여 불가. 적발 시 보너스 회수",
	"sdtzdldh": "천자더리 문자 또는 전화를 받은 초청자는 이벤트 개시 후 매일 첫 두 건 충전 시 혜택 제공",
	"ghdbyrhsb": "이 이벤트는 첫충, 복충 이벤트와 중복 불가",
	"rjfyljyj": "일일 마이너스 수익 구조 조정 지원금",
	"drfyl": "당일 마이너스 수익",
	"crfylflcj": "익일 마이너스 수익 환급 보너스",
	"zcr2330": "참고: 익일 23:30 이전에 신청하지 않으면 자동 포기로 간주",
	"yhsyd": "초청 받은 번호와 계정을 연동한 회원이 당일 손실 발생 시, 익일 10시 이후 전용 상담원에게 문의",
	"drsyyx": "당일 전체 게임 손실은 익일 오전 10시 이후 전용 상담원 통해 처리 가능",
	"dhhdx": "전화/문자 초대 고객이 친구를 채팅방으로 초대 후 앱 등록 시 혜택 제공",
	"sc200": "첫 충전 200위안 시 추천인에게 38위안 보너스, 5배 롤링 후 출금 가능",
	"hymccz": "회원이 충전 시 아래 조건 충족 시마다 '보너스 수령' 참여 가능",
	"dbckje": "단일 충전 금액",
	"tkls": "출금 롤링",
	"jzrhgr": "개인 또는 팀의 부정 이용 금지, 적발 시 책임 본인 부담",
	"chdbcy": "본 이벤트는 제3자 실시간 및 복권 게임과 중복 불가, 적발 시 보너스 회수",
	"bgsxyhdjsq": "본사는 이벤트 해석 및 종료 권리를 보유함!",
	"usdtcz": "USDT 충전 시마다 1% 보너스 제공",
	"yq500": "500위안 이상부터",
	"czdzjk": "충전 완료 시 고객센터 문의로 보너스 수령 가능",
	"czdzxdysj": "충전 직후 바로 문의해야 수령 가능, 게임 이용 후엔 불가",
	"sylqcjbncysfsx": "수령한 보너스는 제3자 실시간, 복권, QP게임 참여 불가. 적발 시 보너스 회수. 본 이벤트는 타 이벤트와 중복 불가",
	"fcc": "복충 이벤트",
	"activity_l01": "천자더리 오픈 전 15일 출석 이벤트",
	"activity_l02": "신규 첫 충전 특별 혜택",
	"activity_l03": "신규 재충전 두 배 혜택",
	"activity_l04": "익일 첫 두 번 충전에 선물 제공",
	"activity_l05": "일일 손실 구조 지원금",
	"activity_l06": "고객 추천 이벤트",
	"activity_l07": "매 충전마다 보너스 지급",
	"activity_l08": "USDT 충전 시 매번 1% 보너스 지급",
	"activity_l09": "신규 첫 충전 특별 혜택",
	"activity_l10": "재충전 혜택",
	"jyxq": "거래 상세",
	"jylx": "거래 유형",
	"jyfs": "거래 방식",
	"zt": "상태",
	"ddhm": "주문 번호",
	"bdzl": "연동 정보",
	"zsxm": "실명",
	"qsrzsxm": "실명을 입력해주세요",
	"qh": "지역번호",
	"bdcg": "연동 성공",
	"szdlmm": "로그인 비밀번호 설정",
	"ymm": "기존 비밀번호",
	"qsrydlmm": "기존 로그인 비밀번호를 입력해주세요",
	"xmm": "새 비밀번호",
	"qsrxdlmm": "새 로그인 비밀번호를 입력해주세요",
	"qrmm": "비밀번호 확인",
	"qzcsrxdlmm": "새 로그인 비밀번호를 다시 입력해주세요",
	"xgcg": "수정 완료, 로그인 화면으로 돌아갑니다",
	"sz": "설정",
	"xg": "수정",
	"qkmm": "출금 비밀번호",
	"qsryqkmm": "기존 출금 비밀번호를 입력해주세요",
	"qsrxqkmm": "새 출금 비밀번호를 입력해주세요",
	"qzcsrxqkmm": "새 출금 비밀번호를 다시 입력해주세요",
	"edzh": "금액 전환",
	"zcyx": "전환할 게임",
	"zryx": "전환받을 게임",
	"w": "나",
	"dt": "천자더리 로비",
	"hyzh": "회원 계정",
	"qhzh": "계정 전환",
	"zd": "베팅 내역",
	"yk": "손익",
	"aqzx": "보안 센터",
	"ryqtyw": "기타 궁금한 점이나 제안사항은",
	"qh1": "전환",
	"dbqk": "단건 출금",
	"qsrqkmm": "출금 비밀번호를 입력해주세요",
	"ljqk": "즉시 출금",
	"rxbzq": "도움이 필요하시면",
	"gl": "관리",
	"qkcg": "출금 성공",
	"nhwbdshhxm": "아직 휴대폰 번호와 실명을 연동하지 않으셨습니다",
	"nhwdlqdl": "로그인하지 않으셨습니다. 로그인해주세요",
	"zwkf": "아직 오픈되지 않았습니다",
	"fzcg": "복사 성공",
	"zwzxkf": "온라인 상담원이 없습니다",
	xz1: '선택',
	xxcqk: '오프라인 입출금',
	xjcqk: '현금 입출금',
	cmcqk: '칩 입출금',
	xsck: '온라인 입금',
	xsqk: '온라인 출금',
	bk: '추가 공제',
	zf1: '포인트 전환',
	hd: '이벤트',
	yj: '커미션',
	fs: '페이백',
	js: '정산',
	wx1: '무효',
	cx: '취소',
	zz: '이체',
	j2r: '최근 2일',
	j7r: '최근 7일',
	j30r: '최근 30일',
	wcl: '미처리',
	dj: 'e스포츠',
	jj1: '아케이드',
	sx1: '라이브 카지노',
	yqx: '취소됨',
	syzd: '전체 베팅 내역',
	zczd: '정상 베팅',
	cszd: '재정산 베팅',
	yzfs: '인증 방식',
	wbhndzhaq: '계정 보안을 위해 인증 방식을 설정하는 것을 권장합니다.',
	ybd: '연결됨',
	bd: '연결',
	dlmm: '로그인 비밀번호',
	qsrymm: '기존 비밀번호를 입력하세요',
	qsrxmm: '새 비밀번호를 입력하세요',
	szcg: '설정 완료',
	ndfsbl: '귀하의 페이백 비율은 상위 에이전트가 설정합니다.',
	rgndsjdl: '상위 에이전트가 비율을 조정하면 실시간으로 반영됩니다.',
	ndqd: '현재 귀하의 페이백 비율은',
	zdl: '확인',
	yy: '언어',
	tcdl: '로그아웃',
	dqbb: '현재 버전',
	qrtcdl: '로그아웃하시겠습니까?',
	1157: "비율 가져오기 실패",
	1158: "계정이 이 플랫폼에 로그인할 수 없습니다",
	1159: "가져오기 실패",
	1160: "URL이 유효하지 않습니다",
	1161: "권한 설정 오류",
	1162: "권한 가져오기 오류",
	1163: "이미 연동됨",
	1164: "대리 결제 실패",
	1165: "Google 인증기가 이미 연동됨",
	1166: "연동 실패",
	1167: "Google 인증 코드 오류",
	1168: "가져오기 실패",
	1169: "사용자가 비활성화됨",
	1170: "설정 실패",
	1172: "주문이 대리 결제로 전환됨",
	1173: "기본 세척 비율 오류",
	1174: "가져오기 실패",
	1175: "게임 위치 업데이트 실패",
	1176: "삭제 실패",
	1177: "데이터 가져오기 실패",
	1178: "작업 실패",
	1179: "조회 실패",
	1180: "이미 즐겨찾기에 추가됨",
	1181: "설정 실패",
	1182: "한도 템플릿 가져오기 실패",
	1183: "한도 템플릿 설정 실패",
	1184: "삭제 실패",
	1185: "시간 간격은 하루를 초과할 수 없습니다",
	1186: "로그인 횟수 초과",
	1187: "유효한 수금 주소를 입력하세요",
	2001: "주문 실패",
	2002: "콜백 오류",
	2003: "콜백 서명 검증 실패",
	2004: "금액이 범위를 초과",
	2005: "환율 가져오기 실패",
	2006: "온라인 충전, 콜백 성공, 상금 프로세스 실패",
	2007: "결제 플랫폼 상태 오류",
	2008: "결제 채널 가져오기 실패",
	2009: "결제 코드 오류",
	2010: "콜백 IP 오류",
	2011: "미지급 주문이 제한을 초과함",
	2012: "채널 존재하지 않음",
	2013: "채널 비활성화됨",
	2014: "채널 금액 설정 오류",
	2015: "결제 설정 오류",
	2016: "출금 콜백 실패",
	2017: "출금 조회 실패",
	2018: "결제 기간 동안 수정 불가",
	2019: "하위 계정보다 적을 수 없음",
	4403: "토큰 갱신 실패",
	1117: "시간 형식 오류",
	1118: "시작 시간이 종료 시간보다 작아야 합니다",
	1119: "조회 간격은 한 달을 초과할 수 없습니다",
	1120: "게임 목록 가져오기 실패",
	1121: "수정된 정보가 없습니다",
	1122: "조회 실패",
	1123: "조회 실패",
	1124: "순위 가져오기 실패",
	1125: "자기 자신을 수정할 수 없음",
	1126: "작업 실패",
	1127: "IP가 이미 존재함",
	1128: "추가 실패, 관리자에게 문의하세요",
	1129: "삭제 실패",
	1130: "IP가 유효하지 않음",
	1131: "가져오기 실패",
	1132: "결제 중복",
	1133: "작업 실패, 관리자에게 문의하세요",
	1134: "작업 실패, 관리자에게 문의하세요",
	1135: "설정 정보 가져오기 실패",
	1136: "로그인 실패",
	1137: "최소 출금 금액은 500입니다",
	1138: "연동 실패",
	1139: "조회 실패",
	1140: "조회 실패",
	1141: "이체 부족",
	1142: "수금 계좌 정보 가져오기 실패",
	1143: "입금 작업 실패",
	1144: "조회 실패",
	1145: "작업 실패",
	1146: "게임 태그 오류",
	1147: "장소 정보 가져오기 실패",
	1148: "정보 가져오기 실패",
	1149: "보고서 가져오기 실패",
	1150: "가져오기 실패",
	1151: "할인 활동 가져오기 실패",
	1152: "결제 태그 가져오기 실패",
	1153: "업로드 실패",
	1154: "수정 실패",
	1155: "상위 계정이 설정되지 않음",
	1156: "상위 계정보다 클 수 없음",
	1157: "하위 계정에서 이 작업을 할 수 없음",
	1057: "재정 처리 실패",
	1063: "송금 실패, 재정 심사 취소만 가능",
	1064: "송금 처리 실패",
	1065: "주문 가져오기 실패",
	1066: "주문 가져오기 실패",
	1067: "재정 알림 가져오기 실패",
	1068: "송금 알림 가져오기 실패",
	1069: "출금 비밀번호를 먼저 설정하세요",
	1070: "로그인 실패!!! 관리자에게 문의하세요!!!",
	1071: "초대 코드 오류",
	1072: "주문 가져오기 실패",
	1073: "전자 점유 비율은 상위 계정보다 클 수 없음",
	1074: "양쪽 세척 비율은 상위 계정보다 클 수 없음",
	1075: "체험 사용자 생성 실패, 나중에 다시 시도하세요",
	1076: "계정 생성 성공, 권한 초기화 실패, 관리자에게 문의하세요",
	1077: "가져오기 실패",
	1078: "데이터가 조회되지 않았습니다",
	1079: "데이터가 조회되지 않았습니다",
	1080: "새로 고침 실패",
	1081: "가져오기 실패",
	1082: "서명 가져오기 실패",
	1083: "공지 가져오기 실패",
	1084: "결제 실패",
	1085: "잔액 부족으로 결제 불가",
	1086: "조회 실패",
	1087: "로그인 실패",
	1088: "게임 목록 가져오기 실패",
	1089: "한도 변환 실패",
	1090: "잔액 부족",
	1091: "플랫폼 오류",
	1092: "전기 세척 비율은 상위 계정보다 클 수 없음",
	1093: "결제 실패",
	1094: "데이터가 조회되지 않았습니다",
	1095: "시작 시간 형식 오류",
	1096: "종료 시간 형식 오류",
	1097: "시작 시간이 종료 시간보다 클 수 없음",
	1098: "결제 금액이 0입니다",
	1099: "종료 시간은 현재 시간보다 클 수 없습니다",
	1100: "설정 가져오기 오류",
	1101: "보고서 조회 실패",
	1102: "하위 계정 가져오기 실패",
	1103: "가져오기 실패",
	1104: "가져오기 실패",
	1105: "가져오기 실패",
	1106: "작업 실패",
	1107: "플랫폼이 존재하지 않음",
	1108: "플랫폼 계정이 존재하지 않음",
	1109: "조회 실패",
	1110: "작업 실패",
	1111: "한도 변환 실패",
	1112: "가져오기 실패",
	1113: "가져오기 실패",
	1114: "결제 금액이 커미션보다 큼",
	1115: "게임 퇴출 실패",
	1116: "게임 설정 가져오기 실패",
	1: "조회 오류",
	2: "인터페이스가 아직 열리지 않았습니다",
	3: "자주 요청하지 마세요",
	4: "수정 실패",
	5: "게임 유지 보수 중",
	6: "플랫폼 계정 생성 실패",
	7: "플랫폼이 열리지 않았습니다",
	8: "게임이 존재하지 않음",
	1002: "사용자 없음",
	1003: "아이디 비밀번호 오류",
	1004: "토큰 생성 실패",
	1005: "원래 비밀번호 오류",
	1006: "수정 실패",
	1007: "계정 상태 가져오기 실패",
	1008: "mysql 오류",
	1010: "계정 생성 실패",
	1011: "계정이 이미 존재함",
	1012: "사용자 정보 조회되지 않음",
	1013: "자기 자신을 수정하지 마세요",
	1014: "잔액 부족",
	1015: "작업 실패",
	1016: "작업 유형 오류",
	1017: "계정 수정 실패",
	1018: "온라인 베팅 목록 가져오기 실패",
	1019: "계정이 존재하지 않음",
	1020: "데이터가 조회되지 않음",
	1021: "기록이 조회되지 않음",
	1022: "조회 오류",
	1023: "계정이 존재하지 않음",
	1024: "조회 실패",
	1025: "데이터가 조회되지 않음",
	1026: "메뉴 가져오기 실패",
	1027: "메뉴 가져오기 실패",
	1028: "메뉴 수정 실패",
	1029: "계정이 다른 곳에서 로그인됨",
	1030: "비밀번호가 변경되었으므로 다시 로그인해야 합니다",
	1031: "권한 부족",
	1032: "인증 코드 오류",
	1033: "로그인 사용자 오류",
	1036: "상위 계정이 존재하지 않음",
	1037: "온라인 목록 가져오기 실패",
	1038: "작업 실패",
	1039: "은행 계좌 이름이 일치하지 않음",
	1040: "은행 계좌 추가 실패",
	1041: "은행 계좌 번호가 이미 존재함",
	1042: "은행 계좌 삭제 실패",
	1043: "금액이 정확하지 않음",
	1045: "작업 성공!!! 플레이어에게 알림 실패, 다시 로그인하여 게임을 시작하세요",
	1046: "계정은 6-20자의 숫자와 문자만 포함할 수 있습니다",
	1047: "휴대폰 인증 코드 오류",
	1049: "사용자가 하나의 은행 계좌만 가지고 있어 삭제할 수 없습니다",
	1050: "삭제 실패",
	1051: "출금 비밀번호 수정 실패",
	1052: "원래 비밀번호 오류",
	1053: "가져오기 실패",
	1054: "출금 비밀번호 설정 실패",
	1055: "사용자가 출금 비밀번호를 이미 설정함",
	1056: "출금 실패",
	wlcwqcs: "네트워크 오류, 다시 시도하십시오"
}